"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M43.763 11.621l-7.42-7.382a1.888 1.888 0 0 0-2.649.18L29.4 8.712l9.88 9.88 4.31-4.319a1.886 1.886 0 0 0 .173-2.652zM26.712 11.4L8.82 29.292a2.232 2.232 0 0 0-.521.813L4.115 41.659a1.654 1.654 0 0 0 2.171 2.186L17.9 39.713a2.231 2.231 0 0 0 .826-.526l17.87-17.9zm-9.658 25.745c-3.1 1.116-6.975 2.517-9.652 3.475l3.456-9.653z" })
);

